import {Component, Input, OnInit} from '@angular/core';
import {MasterSummaryQuestionModel} from '../../../../models/survey/survey.model';
import { ChartName } from '../../../constants/chart.constants';
import {
  allowShowBarchart,
  allowShowPieChart,
  showAverageNumericResponse,
  showMostCommonResponse
} from '../../../helpers/chart-helper';

@Component({
  selector: 'app-summary-question-table',
  templateUrl: './summary-question-table.component.html',
  styleUrls: ['./summary-question-table.component.less']
})

export class SummaryQuestionTableComponent implements OnInit {

  @Input() question: MasterSummaryQuestionModel;
  @Input() combine: boolean;
  @Input() combineLabel: string;

  showDropdown = false;

  barChartLabel = ChartName.BAR_CHART;
  roseChartLabel = ChartName.ROSE_CHART;
  averageChartLabel = ChartName.AVERAGE_CHART;
  mostCommonChartLabel = ChartName.MOST_COMMON_CHART;
  
  constructor() {
  }

  ngOnInit() {
  }

  showChart(barChart: boolean) {
    this.question.barChart = barChart;
    this.question.chart = !barChart;
    this.question.averageResponse = false;
    this.question.mostCommonResponse = false;
  }

  showAverageNumeric() {
    this.question.averageResponse = true;
    this.question.mostCommonResponse = false;
    this.question.barChart = false;
    this.question.chart = false;
  }

  showCommonNumeric() {
    this.question.mostCommonResponse = true;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.averageResponse = false;
  }

  allowShowBarChart(type: string): boolean {
    return allowShowBarchart(type);
  }

  allowShowPieChart(type: string): boolean {
    return allowShowPieChart(type);
  }

  showAverageNumericResponse(type: string): boolean {
    return showAverageNumericResponse(type);
  }

  showMostCommonResponse(type: string): boolean {
    return showMostCommonResponse(type);
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.showDropdown = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/summary-question-table/summary-question-table.component.ts